var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M235.405 162.493v20.96l-91.465 41.569a9.6 9.6 0 0 1-3.94.84c-1.25 0-2.5-.22-3.673-.726l-91.732-38.238v-20.655l95.233 39.679zm0-38.162v20.96L143.94 186.86a9.6 9.6 0 0 1-3.94.84c-1.25 0-2.5-.22-3.673-.726l-91.732-38.238V128.08l95.233 39.679zm-91.528-69.373 85.865 38.162a9.52 9.52 0 0 1 5.667 8.71 9.54 9.54 0 0 1-5.667 8.72l-85.865 38.163a9.6 9.6 0 0 1-3.873.82 9.65 9.65 0 0 1-3.883-.82L50.256 110.55a9.55 9.55 0 0 1-5.657-8.72 9.53 9.53 0 0 1 5.657-8.71l85.865-38.163a9.55 9.55 0 0 1 7.756 0m-3.873 19.148-62.376 27.725 62.376 27.725 62.366-27.725z"
})));
export default SvgLayer;